<!--客户购买体验卡-->
<template>
  <div>
    <el-form ref="registerRef" label-width="120px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="手机号:" prop="phoneNumber">
            <el-input readonly="true" style="width: 270px" v-model="param.phoneNumber" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="小名:" prop="childPetName">
            <el-input style="width: 270px" placeholder="" v-model="param.childPetName" readonly=""></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
          <el-form-item label="月龄:" prop="">
            <el-input
              readonly="true"
              style="width: 270px"
              placeholder=""
              v-model="param.childName"
            ></el-input>
          </el-form-item>
        </el-col> -->
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="会员姓名:" prop="childName">
            <el-input readonly="true" style="width: 270px" v-model="param.childName" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="性别:" prop="childGender">
            <el-select placeholder="请选择" style="width: 270px" v-model="param.childGender" disabled>
              <el-option v-for="item in genderOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-row>
        <el-col :span="12">
          <el-form-item label="小名:" prop="childPetName">
            <el-input style="width: 270px" placeholder="" v-model="param.childPetName" readonly=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="等级:" prop="level">
            <el-select placeholder="请选择" style="width: 270px" v-model="param.level">
              <el-option v-for="item in [
                { label: '一级', value: 1 },
                { label: '二级', value: 2 },
                { label: '三级', value: 3 },
                { label: '四级', value: 4 },
              ]" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row> -->
      <el-row>
        <el-col :span="12">
          <el-form-item label="版本:" prop="lessonId">
            <el-select placeholder="请选择" style="width: 270px" v-model="param.lessonId" @change="changeLessonIdC">
              <el-option v-for="item in [
                { label: 'A', value: 2 },
                { label: 'B', value: 1 },
              ]" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="选择体验卡:" prop="expCardId">
            <el-select style="width: 270px" v-model="param.expCardId" placeholder="请选择">
              <el-option v-for="item in storeLessonExpCards" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="价格:" prop="expCardPay">
            <el-input-number style="width: 270px" v-model="param.expCardPay" placeholder=""
              :precision="2"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="课时:" prop="expCardNum">
            <el-input style="width: 270px" placeholder="" v-model="param.expCardNum" :precision="0" :min="1"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="已购买体验卡:" prop="expCardPay">
            <el-input  v-model="cardNameLis" placeholder="" disabled
             ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注:" prop="remark">
        <el-input type="textarea" :autosize="{ minRows: 4 }" placeholder="请输入内容" style="width: 740px" 
          v-model="param.remark"></el-input>
      </el-form-item>
      <el-form-item label="语音备注:" prop="recording">
        <div style="width: 740px;display: flex;align-items: center;">
          <soundRecording ref="soundRecord" @clickRecStop="clickRecStop" @clickRecClear="clickRecClear" />
          <div v-if="audio" style="margin-left: 20px;">
            <audio controls ref="audio" class="aud" controlsList="nodownload noplaybackrate">
              <source :src="audio" />
            </audio>
          </div>
        </div>
      </el-form-item>

      <!-- <el-form-item label="体验卡次数:">
        <el-input-number
          style="width: 270px"
          v-model="param.cardNum"
          placeholder=""
        ></el-input-number>
      </el-form-item> -->
    </el-form>
    <div slot="footer" class="dialog-footer-1">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleUpdate()">确认</el-button>
    </div>
    <worker-word :key="refreshWord" :word-type="wordType" :t-data="tData" :show="showWordDlg"
      @onWorkerWord="handleWord"></worker-word>
  </div>
</template>

<style></style>

<script>
import commonUtils from "../../../utils/commonUtils";
import { selectChild, updateChildInfo } from "../../../api/userChild";
import messageUtils from "../../../utils/messageUtils";
import globaldata from "../../../utils/globaldata";
import WorkerWord from "../../../components/WorkerWord/WorkerWord";
import { newUserByExpCard } from "../../../api/userByCard";
import soundRecording from "@/components/soundRecording";
import { selectCards, findCardByUserId } from "@/api/storeFront";

export default {
  name: "UserBuyExpCard",
  components: { WorkerWord, soundRecording },
  props: {
    childInfo: Object,
    // storeLessonExpCards: Array,
  },
  data() {
    return {
      rules: {},

      param: {
        expCardPay: 0,
      },
      showWordDlg: false,
      refreshWord: "",
      wordType: "",
      tData: "",

      genderOptions: [
        {
          value: "0",
          label: "男",
        },
        {
          value: "1",
          label: "女",
        },
      ],
      storeLessonExpCards: [],
      audio: '',
      cardNameLis: '',
    };
  },
  mounted() { },
  created() {
    this.initParam();
    this.findCardBy()
  },
  methods: {
    findCardBy() {
      findCardByUserId({
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        userId: this.childInfo.userId,
      }).then((res) => {
        if (res.code == 20000) {
          res.data.forEach(element => {
            this.cardNameLis = this.cardNameLis ? this.cardNameLis + ',' + element.cardName : element.cardName
      // console.log(this.cardNameLis,'this.cardNameLis===')
          });

        }
      })
    },
    clickRecStop(audio) {
      if (audio == 1) {
        this.$refs.soundRecord.recStop()
        let timer = setInterval(() => {
          this.audio = this.$refs.soundRecord.audio
          this.$refs.audio.src = this.audio
          this.$refs.soundRecord.dialogVisible = false
          // console.log(this.$refs.soundRecord.audio, 'refs.soundRecord.audio')
          clearInterval(timer)
        }, 500)
      } else {
        let timer = setInterval(() => {
          this.audio = this.$refs.soundRecord.audio
          this.$refs.audio.src = this.audio
          this.$refs.soundRecord.dialogVisible = false
          // console.log(this.$refs.soundRecord.audio, 'refs.soundRecord.audio')
          clearInterval(timer)
        }, 500)
      }
    },
    clickRecClear() {
      this.audio = ''
    },
    changeLessonIdC(e) {
      console.log("changeLessonIdC", e);
      if (e) {
        this.getStoreLessonCard(e);
      } else {
        this.$set(this.param, "expCardId", null);
        this.storeLessonExpCards = [];
      }
    },
    async getStoreLessonCard(lessonId) {
      let self = this;
      const response = await selectCards({
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        statu: 0,
        exp: 1,
        lessonId,
      });
      if (response.code === 20000) {
        self.storeLessonExpCards = response.data;
      }
    },
    handleCancel() {
      this.$emit("onBtnCancel");
    },
    // 初始化参数
    initParam() {
      this.param = {
        ...this.childInfo,
        expCardPay: 0,
        lessonId: null,
        expCardId: null,
        expCardNum: 1,
      };
      this.$nextTick(() => {
        this.audio = this.childInfo.recording
        this.$refs.soundRecord.audio = this.childInfo.recording
        this.$refs.soundRecord.localUrl = this.childInfo.recording
        console.log(this.$refs, 'this.$refs.soundRecord========')
      })

    },

    handleUpdate() {
      let paramst = {
        ...this.param,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        userId: this.childInfo.userId,
        storeLessonCardId: this.param.expCardId,
        totalPay: this.param.expCardPay,
        remark: this.param.remark,
        cardNum: this.param.cardNum,
        // audio:this.$refs.soundRecord.audio,
        audio: this.audio,
      };
      // console.log(this.$refs.soundRecord.audio,this.param,'paramstparamstparamstparamst',paramst)
      this.doRefreshWord(true, 1, paramst);
    },

    doBuyExpCard(param) {
      newUserByExpCard(param).then((response) => {
        this.closeWordDlg();
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          messageUtils.errorMsg(this, response.message);
          return;
        }
        messageUtils.successMsg(this, response.message);
        this.$emit("handleBuy");
      });
    },

    handleWord(wordType, tData) {
      if (wordType == 1) {
        this.doBuyExpCard(tData);
      }
    },

    doRefreshWord(show, wordType, tData) {
      this.tData = tData;
      this.wordType = wordType;

      this.showWordDlg = show;
      this.refreshWord = new Date().getTime();
    },
    closeWordDlg() {
      this.wordTitle = "";
      this.wordType = 0;
      this.showWordDlg = false;
      this.refreshWord = new Date().getTime();
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-input.is-disabled .el-input__inner {
  background: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/views/user_child/components/UserBuyExpCard.vue